import React from 'react';
import { UnderlinedText } from '@zola/zola-ui/src/components/UnderlinedText';

type Copy = {
  title: string;
  description: string | JSX.Element;
};

const numberedListCopy: Copy[] = [
  {
    title: 'We’ll Help You Add Cash Funds',
    description: (
      <span>
        Create funds for <UnderlinedText color="hardPink"> any </UnderlinedText> amount. You can let
        guests contribute what they want or contribute fixed amounts.
      </span>
    ),
  },
  {
    title: 'Guests Will Give You Cash',
    description: (
      <span>
        They’ll visit one <UnderlinedText color="hardPink">convenient</UnderlinedText> page to
        browse your honeymoon funds, plus any gift cards or classic gifts you add.
      </span>
    ),
  },
  {
    title: 'You’ll Spend Your Cash',
    description: (
      <span>
        Transfer honeymoon fund contributions to your bank account{' '}
        <UnderlinedText color="hardPink">anytime.</UnderlinedText>
      </span>
    ),
  },
];

export default numberedListCopy;
